module.exports = __webpack_public_path__ + "img/2.e0e4e7d9.png";